import * as moment from 'moment';

const getMonthDay = (year, month) => {
  // 해당 월 일수
  return 32 - new Date(year, month - 1, 32).getDate();
};

const getThisMonthDay = () => {
  const date = getThisData();

  return getMonthDay(date.toYear, date.toMonth);
};

const getThisData = () => {
  const date = new Date();
  const toYear = date.getFullYear();
  const toMonth = date.getMonth() + 1;
  const toDay = date.getDate();
  const toHour = date.getHours();
  const toMinute = date.getMinutes();
  const toSeconds = date.getSeconds();
  let nextMonth = date.getMonth() + 2;

  if (nextMonth === 13) {
    nextMonth = 1;
  }

  const monthDay = getMonthDay(toYear, toMonth);

  return {
    toYear,
    toMonth,
    toDay,
    toHour,
    toMinute,
    toSeconds,
    nextMonth,
    monthDay,
  };
};

//오늘 남은 시간(페이백챌린지 데일리미션 남은시간 체킹)
const getDistance = endTimestamp => {
  // console.log('getDistance', {
  //   endTimestamp,
  // });

  const endTime = new Date(endTimestamp);
  endTime.setHours(23);
  endTime.setMinutes(59);
  endTime.setSeconds(59);

  // const endTime = new Date(ts);
  // console.log({ endTime });
  const currentTime = new Date();
  let distance = endTime - currentTime;

  // let distance = currentTime - endTime;
  let sign = false;
  if (distance < 0) {
    distance = 0;
    sign = true;
  }

  const remainingTime = getRemainingTimeForTimestamp(distance, sign);
  // console.log({ distance, remainingTime });
  return remainingTime;
};

const getRemainingTimeForTimestamp = (timestamp, sign) => {
  if (sign) timestamp = -timestamp;
  const second = 1000;
  const min = second * 60;
  const hour = min * 60;
  const day = hour * 24;
  // console.log({ timestamp, sign });

  const dd = Math.floor(timestamp / day);
  const hh = Math.floor((timestamp / hour) % 24);
  const mm = Math.floor((timestamp / min) % 60);
  const ss = Math.floor((timestamp / second) % 60);

  let string = `${dd ? dd + '일 ' : ''} ${hh ? hh + '시간 ' : ''} ${
    mm ? mm + '분 ' : ''
  } ${ss ? ss + '초 ' : ''}`.trim();

  if (!string) {
    string = `0초`;
  }

  const date = {
    dd,
    hh,
    mm,
    ss,
    string,
  };
  // console.log({ date });

  return date;
};

//챌린지 시작까지 남은 Day일수
const getReminderDay = () => {
  const nDate = new Date();
  const nYear = nDate.getFullYear();
  const nMonth = nDate.getMonth() + 1;
  const nDay = nDate.getDate();

  const rDay = getMonthDay(nYear, nMonth) - nDay;

  return rDay;
};

//한정혜택
const getNextWeekday = addDay => {
  const Timer = () => {
    let nowTime = moment().format('YYYY/MM/DD HH:mm:ss');
    let limitTime = moment().format('YYYY/MM/DD 17:29:59');

    // console.log('ds', nowTime, limitTime, nDay);
    let timeText = document.getElementById('limitTime');
    let lDate = '';
    if (nowTime > limitTime) {
      moment()
        .add(addDay, 'd')
        .format('M/D');

      if (timeText) {
        lDate = timeText.innerHTML =
          moment()
            .add(addDay, 'd')
            .format('M/D') + '마감 한정 혜택';
        limitTime = moment()
          .add(addDay, 'd')
          .format('YYYY/MM/DD 17:29:59');
      }
    } else {
      if (timeText) {
        lDate = timeText.innerHTML = moment().format('M/D') + '마감 한정 혜택';
      } else {
        return null;
      }
    }
    // console.log('nowTime > limitTime', nowTime, limitTime);
    return lDate;
  };

  setInterval(() => {
    Timer();
  }, 1000);
};

//쿠푠 만료까지 남은시간
const couponEndTime = edate => {
  const endDate = moment(edate).toDate();

  const second = 1000;
  const min = second * 60;
  const hour = min * 60;
  const day = hour * 24;

  const showTime = () => {
    const nowDate = moment().toDate();
    let cha = endDate - nowDate;

    let days = Math.floor(cha / day);
    let hours = Math.floor((cha % day) / hour);
    let minutes = Math.floor((cha % hour) / min);
    let seconds = Math.floor((cha % min) / second);

    if (endDate > nowDate) {
      return `
      ${days ? days + '일 ' : ''}
      ${hours.toString().padStart(2, '0')}:
      ${minutes.toString().padStart(2, '0')}:
      ${seconds.toString().padStart(2, '0')}`;
    } else {
      return `쿠폰 기간이 끝났습니다.`;
    }
  };

  return showTime();
};

//오늘 남은시간 계산
const countTime = type => {
  let toDay = moment()
    .endOf(type)
    .diff();
  let cDay = moment.duration(toDay);
  console.log('toDay', toDay);
  console.log('cDay', cDay);
  let time = `${cDay.hours()}:${
    cDay.minutes() >= 10 ? cDay.minutes() : '0' + cDay.minutes()
  }:${cDay.seconds() >= 10 ? cDay.seconds() : '0' + cDay.seconds()}`;
  return time;
};

// 3/2일 날짜 체크
const chkDate = (sDate, eDate) => {
  let nowDate = moment().format('YYYY-MM-DD HH:mm:ss');
  let startDate = moment().format(sDate);
  let endDate = moment().format(eDate);

  let chk = false;
  if (nowDate > startDate) {
    // console.log('5로 변경');
    // console.log(nowDate, endDate);
    chk = true;
  }
  if (nowDate > endDate) {
    // console.log('기존으로 변경');
    // console.log(nowDate, endDate);
    chk = false;
  }
  // console.log('끝', nowDate, endDate);
  return chk;
};

export {
  getThisData,
  getThisMonthDay,
  getMonthDay,
  getDistance,
  getRemainingTimeForTimestamp,
  getReminderDay,
  getNextWeekday,
  couponEndTime,
  chkDate,
  countTime,
};
